export default __webpack_public_path__ + "static/media/antigenoSmall.41ac5f6c.png";